$(document).ready(function() {

	// -- Vars --
 	var municipalityIsotopeSettings = {
	  itemSelector: '.municipality__grid__item',
	  layoutMode: 'fitRows',
	  percentPosition: true,
	  filter: ':not(*)'
	};

	// -- Buttons filter --
	$('.municipality__header .btn--link').on('click', function(){
		$('.municipality__header .btn--link').removeClass('active');
		$(this).addClass('active');
		var selectClass = $(this).attr('data-select');
		var param = $('select[name="' + selectClass + '"]').val();
		$('.municipality__header .input__wrapper.select').hide();
		$('.' + selectClass).show();
		$municipalityGrid.isotope({ filter: param });
	});

	// -- Init Isotope --
	var $municipalityGrid = $('.municipality__grid').isotope(municipalityIsotopeSettings);
	// -- Init Isotope after each image loads --
	$municipalityGrid.imagesLoaded().progress( function() {
	  $municipalityGrid.isotope('layout');
	});

  $('.searchClassForm select').on('change', function(){
  	var param = $(this).val();
		$municipalityGrid.isotope({ filter: param });
		// console.log($('.registration__wrapper').offset().top-20);
		$('.registration__wrapper').html('');
  });

  // -- Update isotope on details/summary click --
  $('.municipality__grid details summary').on('click', function(){
	  setTimeout(function(){
	  	$municipalityGrid.isotope('layout');
	  },0);
  });

});